module.exports = __webpack_public_path__ + "static/media/medvice-logo.967af66c.svg";